export default __webpack_public_path__ + "static/media/EAST2470.34I-34277_-18527_0.6a513a80.jpg";